import { useState } from "react";
import { API_BASE_URL } from "@/mocks/adminData";

interface LoginPageProps {
  onLogin: (token: string) => void;
}

export default function LoginPage({ onLogin }: LoginPageProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    if (!username || !password) { setError("请输入账号和密码"); return; }
    setLoading(true); setError("");
    try {
      const res = await fetch(`${API_BASE_URL}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (data.code === 200 && data.data?.token) {
        localStorage.setItem("hx_admin_token", data.data.token);
        onLogin(data.data.token);
      } else {
        setError(data.msg || "账号或密码错误");
      }
    } catch {
      setError("无法连接到服务器，请检查后端是否正常运行");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl p-8 w-full max-w-sm border border-gray-100">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-orange-400">
            <span className="text-white font-black text-sm">HX</span>
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-800">合盈集团后台</h1>
            <p className="text-xs font-medium text-gray-500">管理员登录</p>
          </div>
        </div>
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600 flex items-center gap-2">
            <i className="ri-error-warning-line"></i>{error}
          </div>
        )}
        <div className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-gray-600 mb-1 block">用户名</label>
            <input value={username} onChange={e => setUsername(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-red-400 transition-colors"
              placeholder="请输入用户名" />
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-600 mb-1 block">密码</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleLogin()}
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-red-400 transition-colors"
              placeholder="请输入密码" />
          </div>
          <button onClick={handleLogin} disabled={loading}
            className="w-full py-3 bg-gradient-to-r from-red-500 to-orange-400 text-white rounded-lg font-semibold text-sm cursor-pointer hover:opacity-90 transition-opacity disabled:opacity-50 whitespace-nowrap">
            {loading ? "登录中..." : "登录"}
          </button>
        </div>
        <p className="text-xs font-medium text-gray-500 text-center mt-4">默认账号: admin / admin123</p>
      </div>
    </div>
  );
}
